export type SslCheckTls = {
  issued?: boolean
  reason?: string | null
  subject?: { CN?: string }
  issuer?: { CN?: string; O?: string }
  valid_from?: string
  valid_to?: string
}

export type SslPresentation = {
  issued: boolean
  label: string
  color: 'green' | 'red'
  hint: string | null
}

function isTraefikDefault(tls: SslCheckTls): boolean {
  if (tls.reason === 'traefik_default') return true
  return /traefik\s+default\s+cert/i.test(String(tls.subject?.CN || ''))
}

export function sslPresentation(tls: SslCheckTls | null | undefined): SslPresentation | null {
  if (!tls) return null
  if (isTraefikDefault(tls) || tls.issued === false) {
    if (isTraefikDefault(tls)) {
      return {
        issued: false,
        label: 'Не выпущен',
        color: 'red',
        hint: 'Traefik отдал сертификат по умолчанию. Сертификат для домена не выпущен.',
      }
    }
    if (tls.reason === 'hostname_mismatch') {
      return {
        issued: false,
        label: 'Не для этого домена',
        color: 'red',
        hint: 'Имя в сертификате не совпадает с проверяемым доменом.',
      }
    }
    return {
      issued: false,
      label: 'Не выпущен',
      color: 'red',
      hint: 'Сертификат для домена не выпущен.',
    }
  }
  return { issued: true, label: 'Выпущен', color: 'green', hint: null }
}
